"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native"); // todo merge with the other FormInput


var PhoneInput =
/** @class */
function (_super) {
  __extends(PhoneInput, _super);

  function PhoneInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isActive: false,
      isError: _this.props.isError || false,
      isDisabled: _this.props.isDisabled || false
    };

    _this.toggleActive = function () {
      _this.setState(function (prevState) {
        return {
          isActive: !prevState.isActive
        };
      });
    };

    _this.handleBlur = function () {
      var _a = _this.props,
          setFieldTouched = _a.setFieldTouched,
          name = _a.name,
          onBlur = _a.onBlur;
      setFieldTouched(name);

      _this.toggleActive();

      if (onBlur) {
        onBlur();
      }
    };

    _this.handleChange = function (value) {
      var _a = _this.props,
          setFieldValue = _a.setFieldValue,
          name = _a.name,
          onChangeText = _a.onChangeText,
          isSubmitting = _a.isSubmitting;

      var phone = _this.phoneInput(value, _this.props.values[name]);

      if (!isSubmitting) {
        setFieldValue(name, phone);

        if (onChangeText) {
          onChangeText();
        }
      }
    };

    _this.handleKeyPress = function (event) {
      event.preventDefault();
      var key = event.key;
      var _a = _this.props,
          handleSubmit = _a.handleSubmit,
          setFieldTouched = _a.setFieldTouched,
          name = _a.name,
          values = _a.values,
          isValid = _a.isValid,
          onBlur = _a.onBlur;
      var enterKey = 'Enter';

      if (key === enterKey && values[name] && isValid && !onBlur) {
        handleSubmit();
      } else if (key === enterKey && values[name] && onBlur) {
        onBlur();
      } else if (key === enterKey) {
        setFieldTouched(name);
      }
    };

    return _this;
  }

  PhoneInput.prototype.phoneInput = function (value, previousValue) {
    if (!value) return value;
    var currentValue = value.replace(/[^\d]/g, '');

    if (!previousValue || value.length > previousValue.length) {
      if (currentValue.length <= 3) return currentValue;
      if (currentValue.length === 3) return "(" + currentValue + ")";
      if (currentValue.length <= 6) return "(" + currentValue.slice(0, 3) + ") " + currentValue.slice(3);
      if (currentValue.length === 6) return "(" + currentValue.slice(0, 3) + ") " + currentValue.slice(3) + "-";
      return "(" + currentValue.slice(0, 3) + ") " + currentValue.slice(3, 6) + "-" + currentValue.slice(6, 10);
    }

    return value;
  };

  PhoneInput.prototype.render = function () {
    var _a = this.props,
        editable = _a.editable,
        onTouchStart = _a.onTouchStart,
        touched = _a.touched,
        value = _a.value,
        values = _a.values,
        errors = _a.errors,
        label = _a.label,
        placeholder = _a.placeholder,
        name = _a.name,
        linkedField = _a.linkedField,
        isLoading = _a.isLoading,
        isSubmitting = _a.isSubmitting,
        isDisabled = _a.isDisabled,
        accessibilityLabel = _a.accessibilityLabel;
    var isError = this.state.isError || touched[name] && errors[name] || linkedField && errors[linkedField];
    var keyPressHandler = react_native_1.Platform.select({
      web: this.handleKeyPress
    });
    return react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.StyledInputLabel, null, label || placeholder), react_1.default.createElement(components_lib_1.RowWrapper, null, react_1.default.createElement(components_lib_1.FlagIcon, null), react_1.default.createElement(components_lib_1.StyledTextInput, {
      value: value || values[name],
      onChangeText: this.handleChange,
      placeholder: placeholder,
      onFocus: this.toggleActive,
      onBlur: this.handleBlur,
      editable: editable || !isSubmitting,
      onTouchStart: onTouchStart,
      isActive: this.state.isActive,
      isError: isError,
      isDisabled: isDisabled || isSubmitting,
      paddingLeft: '50px',
      onKeyPress: keyPressHandler,
      accessibilityLabel: accessibilityLabel
    }), react_1.default.createElement(components_lib_1.ValidationIconWrapper, null, isLoading ? react_1.default.createElement(components_lib_1.LoadingIndicator, {
      size: 'small'
    }) : touched[name] ? react_1.default.createElement(components_lib_1.ValidationIcon, {
      isValid: !isError
    }) : null)), this.props.children, react_1.default.createElement(react_native_1.View, null, !isLoading && isError && react_1.default.createElement(components_lib_1.RenderError, {
      errorText: errors[name]
    }), !isLoading && linkedField && errors[linkedField] && react_1.default.createElement(components_lib_1.RenderError, {
      errorText: errors[linkedField]
    })));
  };

  return PhoneInput;
}(react_1.default.Component);

exports.default = responsive_1.withResponsiveMeta(PhoneInput);